import { render, staticRenderFns } from "./SalesAccountList.vue?vue&type=template&id=afc69446&scoped=true"
import script from "./SalesAccountList.vue?vue&type=script&lang=js"
export * from "./SalesAccountList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afc69446",
  null
  
)

export default component.exports